export default __webpack_public_path__ + "assets/samoa-flag.png";